import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20b9b64c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = {
  title: "",
  style: {"width":"1000px","margin":"0 auto"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("打印")
const _hoisted_4 = {
  id: "printMe",
  class: "print",
  style: {"margin-top":"5px"}
}
const _hoisted_5 = { style: {"padding":"10px","margin":"15px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "应聘人员登记表", -1))
const _hoisted_7 = { class: "company" }
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = { class: "table" }
const _hoisted_11 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"60px"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "姓名")
], -1))
const _hoisted_13 = { style: {"width":"95px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"60px"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "性别")
], -1))
const _hoisted_15 = { style: {"width":"60px"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"57px"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "民族")
], -1))
const _hoisted_17 = { style: {"width":"80px"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"52px"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "婚否")
], -1))
const _hoisted_19 = {
  key: 0,
  style: {"width":"80px"}
}
const _hoisted_20 = {
  key: 1,
  style: {"width":"80px"}
}
const _hoisted_21 = {
  key: 2,
  style: {"width":"80px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"60px","font-size":"11px"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "出生年月日时")
], -1))
const _hoisted_23 = { style: {"width":"80px"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"52px","border-right-style":"none"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "照")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"52px","border-left-style":"none"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "片")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "家庭详细地址")
], -1))
const _hoisted_27 = { colspan: "5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "政治面貌")
], -1))
const _hoisted_29 = {
  key: 0,
  colspan: "1"
}
const _hoisted_30 = {
  key: 1,
  colspan: "1"
}
const _hoisted_31 = {
  key: 2,
  colspan: "1"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border-bottom-style":"none"}
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "原籍")
], -1))
const _hoisted_34 = { colspan: "2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "健康状况")
], -1))
const _hoisted_36 = {
  key: 0,
  colspan: "1"
}
const _hoisted_37 = {
  key: 1,
  colspan: "1"
}
const _hoisted_38 = {
  key: 2,
  colspan: "1"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "身份证")
], -1))
const _hoisted_40 = { colspan: "2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border-top-style":"none","border-bottom-style":"none"}
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "毕业学校")
], -1))
const _hoisted_43 = { colspan: "2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "专业")
], -1))
const _hoisted_45 = { colspan: "2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "学历")
], -1))
const _hoisted_47 = {
  key: 0,
  colspan: "1"
}
const _hoisted_48 = {
  key: 1,
  colspan: "1"
}
const _hoisted_49 = {
  key: 2,
  colspan: "1"
}
const _hoisted_50 = {
  key: 3,
  colspan: "1"
}
const _hoisted_51 = {
  key: 4,
  colspan: "1"
}
const _hoisted_52 = {
  key: 5,
  colspan: "1"
}
const _hoisted_53 = {
  key: 6,
  colspan: "1"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border-top-style":"none","border-bottom-style":"none"}
}, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "职称")
], -1))
const _hoisted_56 = { colspan: "2" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "期望待遇")
], -1))
const _hoisted_58 = { colspan: "1" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "联系电话")
], -1))
const _hoisted_60 = { colspan: "1" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border-top-style":"none"}
}, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "微机操作")
], -1))
const _hoisted_63 = { colspan: "4" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "紧急联系人电话")
], -1))
const _hoisted_65 = { colspan: "4" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "12" }, [
    /*#__PURE__*/_createElementVNode("b", null, "家庭主要成员")
  ])
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
    /*#__PURE__*/_createElementVNode("b", null, "姓名")
  ]),
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
    /*#__PURE__*/_createElementVNode("b", null, "关系")
  ]),
  /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, [
    /*#__PURE__*/_createElementVNode("b", null, "工作单位(没有单位的填住址)")
  ]),
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
    /*#__PURE__*/_createElementVNode("b", null, "职务")
  ])
], -1))
const _hoisted_68 = { colspan: "2" }
const _hoisted_69 = {
  key: 0,
  colspan: "2"
}
const _hoisted_70 = {
  key: 1,
  colspan: "2"
}
const _hoisted_71 = {
  key: 2,
  colspan: "2"
}
const _hoisted_72 = {
  key: 3,
  colspan: "2"
}
const _hoisted_73 = {
  key: 4,
  colspan: "2"
}
const _hoisted_74 = {
  key: 5,
  colspan: "2"
}
const _hoisted_75 = {
  key: 6,
  colspan: "2"
}
const _hoisted_76 = {
  key: 7,
  colspan: "2"
}
const _hoisted_77 = {
  key: 8,
  colspan: "2"
}
const _hoisted_78 = {
  colspan: "6",
  style: {"text-align":"left"}
}
const _hoisted_79 = { colspan: "2" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "个人爱好/特长")
], -1))
const _hoisted_81 = {
  colspan: "9",
  style: {"text-align":"left"}
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "自我能力评估")
], -1))
const _hoisted_83 = {
  colspan: "9",
  style: {"text-align":"left"}
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "选择岗位")
], -1))
const _hoisted_85 = {
  colspan: "9",
  style: {"text-align":"left"}
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "其他要求")
], -1))
const _hoisted_87 = {
  colspan: "9",
  style: {"text-align":"left"}
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "生活习惯")
], -1))
const _hoisted_89 = {
  colspan: "9",
  style: {"text-align":"left"}
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "12" }, [
    /*#__PURE__*/_createElementVNode("b", null, "个人简历")
  ])
], -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
    /*#__PURE__*/_createElementVNode("b", null, "时间")
  ]),
  /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, [
    /*#__PURE__*/_createElementVNode("b", null, "教育经历/工作经历")
  ]),
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
    /*#__PURE__*/_createElementVNode("b", null, "职位")
  ]),
  /*#__PURE__*/_createElementVNode("td", { colspan: "1" }, [
    /*#__PURE__*/_createElementVNode("b", null, "证明人")
  ]),
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
    /*#__PURE__*/_createElementVNode("b", null, "证明人电话")
  ])
], -1))
const _hoisted_92 = {
  colspan: "3",
  style: {"text-align":"left"}
}
const _hoisted_93 = { style: {"overflow":"auto"} }
const _hoisted_94 = {
  colspan: "4",
  style: {"text-align":"left"}
}
const _hoisted_95 = { style: {"overflow":"auto"} }
const _hoisted_96 = {
  colspan: "2",
  style: {"text-align":"left"}
}
const _hoisted_97 = { style: {"overflow":"auto"} }
const _hoisted_98 = {
  key: 0,
  colspan: "1",
  style: {"text-align":"left"}
}
const _hoisted_99 = {
  key: 1,
  colspan: "1",
  style: {"text-align":"left"}
}
const _hoisted_100 = {
  key: 2,
  colspan: "1",
  style: {"text-align":"left"}
}
const _hoisted_101 = {
  key: 3,
  colspan: "1",
  style: {"text-align":"left"}
}
const _hoisted_102 = {
  key: 4,
  colspan: "1",
  style: {"text-align":"left"}
}
const _hoisted_103 = {
  key: 5,
  colspan: "1",
  style: {"text-align":"left"}
}
const _hoisted_104 = {
  key: 6,
  colspan: "1",
  style: {"text-align":"left"}
}
const _hoisted_105 = {
  colspan: "2",
  style: {"text-align":"left"}
}
const _hoisted_106 = { style: {"overflow":"auto"} }
const _hoisted_107 = {
  colspan: "3",
  style: {"text-align":"left"}
}
const _hoisted_108 = { style: {"overflow":"auto"} }
const _hoisted_109 = {
  colspan: "4",
  style: {"text-align":"left"}
}
const _hoisted_110 = { style: {"overflow":"auto"} }
const _hoisted_111 = {
  colspan: "2",
  style: {"text-align":"left"}
}
const _hoisted_112 = { style: {"overflow":"auto"} }
const _hoisted_113 = {
  colspan: "1",
  style: {"text-align":"left"}
}
const _hoisted_114 = { style: {"overflow":"auto"} }
const _hoisted_115 = {
  colspan: "2",
  style: {"text-align":"left"}
}
const _hoisted_116 = { style: {"overflow":"auto"} }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"border-bottom-style":"none","text-align":"left"}
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "初试意见：")
  ]),
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"border-bottom-style":"none","text-align":"left"}
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "部门负责人意见：")
  ])
], -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"height":"120px"}
  }),
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"height":"120px"}
  })
], -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "12",
    style: {"text-align":"left","border-bottom":"0px solid #ffffff"}
  }, "分管领导意见：")
], -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "12",
    style: {"height":"120px"}
  })
], -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, [
    /*#__PURE__*/_createElementVNode("b", null, "应聘人员签名")
  ]),
  /*#__PURE__*/_createElementVNode("td", { colspan: "9" })
], -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "12",
    style: {"text-align":"left"}
  }, "注：本表分正反两面，应聘人员请严格按表格要求填写，未按表格要求填写的，视为没有应聘诚意，概不受理应聘。")
], -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"page-break-after":"always"} }, null, -1))
const _hoisted_124 = { style: {"height":"1200px","margin-top":"30px"} }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"border":"0","margin-top":"10px","font-weight":"bold"}
}, "价值需求评测答题", -1))
const _hoisted_126 = {
  class: "table-col",
  style: {"margin-top":"10px"}
}
const _hoisted_127 = {
  style: {"border":"none"},
  class: "table2",
  cellspacing: "0",
  cellpadding: "0",
  valign: "top",
  border: "0"
}
const _hoisted_128 = {
  style: {"font-size":"14px"},
  valign: "top"
}
const _hoisted_129 = { valign: "top" }
const _hoisted_130 = {
  class: "result-td",
  style: {"width":"330px","border":"none"}
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "结果"),
  /*#__PURE__*/_createElementVNode("td", null, "题目"),
  /*#__PURE__*/_createElementVNode("td", null, "得分")
], -1))
const _hoisted_132 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_133 = { style: {"display":"flex","margin":"15px 0 0 0"} }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计 算：", -1))
const _hoisted_135 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_136 = /*#__PURE__*/_createTextVNode("一、四、五、八 合为A ")
const _hoisted_137 = { style: {"border-bottom":"1px solid black"} }
const _hoisted_138 = { style: {"margin":"15px 0 0 0"} }
const _hoisted_139 = /*#__PURE__*/_createTextVNode("二、三、六、七 合为B ")
const _hoisted_140 = { style: {"border-bottom":"1px solid black"} }
const _hoisted_141 = { style: {"display":"flex","margin":"15px 0 0 0"} }
const _hoisted_142 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_143 = /*#__PURE__*/_createTextVNode("总分数： ")
const _hoisted_144 = { style: {"border-bottom":"1px solid black"} }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"page-break-after":"always"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            size: "mini",
            type: "primary",
            style: {"margin-bottom":"30px"}
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })), [
            [_directive_print, '#printMe']
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("b", null, "应聘职位：" + _toDisplayString(_ctx.printData.position), 1)
                ]),
                _createElementVNode("div", _hoisted_9, " 填表时间：" + _toDisplayString(_ctx.printData.create_time), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("table", _hoisted_11, [
                  _createElementVNode("tr", null, [
                    _hoisted_12,
                    _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.printData.name), 1),
                    _hoisted_14,
                    _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.printData.gender == 0
                        ? "保密"
                        : _ctx.printData.gender == 1
                        ? "男"
                        : "女"), 1),
                    _hoisted_16,
                    _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.printData.ethnic_group), 1),
                    _hoisted_18,
                    (_ctx.printData.marital_status == 0)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, "未婚"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.marital_status == 1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_20, "已婚"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.marital_status == 2)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_21, "离异"))
                      : _createCommentVNode("", true),
                    _hoisted_22,
                    _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.printData.birthday) + " " + _toDisplayString(_ctx.printData.birthday_time), 1),
                    _hoisted_24,
                    _hoisted_25
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_26,
                    _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.printData.home_address), 1),
                    _hoisted_28,
                    (_ctx.printData.political_landscape == 0)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_29, " 群众 "))
                      : _createCommentVNode("", true),
                    (_ctx.printData.political_landscape == 1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_30, " 团员 "))
                      : _createCommentVNode("", true),
                    (_ctx.printData.political_landscape == 2)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_31, " 党员 "))
                      : _createCommentVNode("", true),
                    _hoisted_32
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_33,
                    _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.printData.ancestral_home), 1),
                    _hoisted_35,
                    (_ctx.printData.health_status == 1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_36, "健康"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.health_status == 2)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_37, "亚健康"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.health_status == 3)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_38, "其他"))
                      : _createCommentVNode("", true),
                    _hoisted_39,
                    _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.printData.id_number), 1),
                    _hoisted_41
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_42,
                    _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.printData.graduate_school), 1),
                    _hoisted_44,
                    _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.printData.major), 1),
                    _hoisted_46,
                    (_ctx.printData.degree==1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_47, "初中及以下"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.degree==2)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_48, "高中"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.degree==3)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_49, "中专/中技"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.degree==4)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_50, "大专"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.degree==5)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_51, "本科"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.degree==6)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_52, "硕士"))
                      : _createCommentVNode("", true),
                    (_ctx.printData.degree==7)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_53, "MBA/EMBA"))
                      : _createCommentVNode("", true),
                    _hoisted_54
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_55,
                    _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.printData.job_title), 1),
                    _hoisted_57,
                    _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.printData.salary), 1),
                    _hoisted_59,
                    _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.printData.phone), 1),
                    _hoisted_61
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_62,
                    _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.printData.microcomputer_operation), 1),
                    _hoisted_64,
                    _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.printData.emergency_contact), 1)
                  ]),
                  _hoisted_66,
                  _hoisted_67,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printData.family_members, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      style: {"height":"20px"},
                      key: i
                    }, [
                      _createElementVNode("td", _hoisted_68, _toDisplayString(item.name), 1),
                      (item.relationship == 1)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_69, "父子"))
                        : _createCommentVNode("", true),
                      (item.relationship == 2)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_70, "母子"))
                        : _createCommentVNode("", true),
                      (item.relationship == 3)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_71, "父女"))
                        : _createCommentVNode("", true),
                      (item.relationship == 4)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_72, "母女"))
                        : _createCommentVNode("", true),
                      (item.relationship == 5)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_73, "兄弟"))
                        : _createCommentVNode("", true),
                      (item.relationship == 6)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_74, "兄妹"))
                        : _createCommentVNode("", true),
                      (item.relationship == 7)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_75, "姐弟"))
                        : _createCommentVNode("", true),
                      (item.relationship == 8)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_76, "姐妹"))
                        : _createCommentVNode("", true),
                      (item.relationship == 9)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_77, "夫妻"))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_78, _toDisplayString(item.workplace), 1),
                      _createElementVNode("td", _hoisted_79, _toDisplayString(item.job_title), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("tr", null, [
                    _hoisted_80,
                    _createElementVNode("td", _hoisted_81, _toDisplayString(_ctx.printData.hobbies), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_82,
                    _createElementVNode("td", _hoisted_83, _toDisplayString(_ctx.printData.competency_assessment), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_84,
                    _createElementVNode("td", _hoisted_85, _toDisplayString(_ctx.printData.position), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_86,
                    _createElementVNode("td", _hoisted_87, _toDisplayString(_ctx.printData.other_requirement), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_88,
                    _createElementVNode("td", _hoisted_89, _toDisplayString(_ctx.printData.daily_habits), 1)
                  ]),
                  _hoisted_90,
                  _hoisted_91,
                  (_ctx.printData.experience)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.printData.experience.educations, (item, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          style: {},
                          key: i
                        }, [
                          _createElementVNode("td", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, _toDisplayString(item.date_start.slice(0,7)) + "-" + _toDisplayString(item.date_end.slice(0,7)), 1)
                          ]),
                          _createElementVNode("td", _hoisted_94, [
                            _createElementVNode("div", _hoisted_95, _toDisplayString(item.school), 1)
                          ]),
                          _createElementVNode("td", _hoisted_96, [
                            _createElementVNode("div", _hoisted_97, _toDisplayString(item.major), 1)
                          ]),
                          (_ctx.printData.degree==1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_98, "初中及以下"))
                            : _createCommentVNode("", true),
                          (_ctx.printData.degree==2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_99, "高中"))
                            : _createCommentVNode("", true),
                          (_ctx.printData.degree==3)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_100, "中专/中技"))
                            : _createCommentVNode("", true),
                          (_ctx.printData.degree==4)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_101, "大专"))
                            : _createCommentVNode("", true),
                          (_ctx.printData.degree==5)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_102, "本科 "))
                            : _createCommentVNode("", true),
                          (_ctx.printData.degree==6)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_103, "硕士"))
                            : _createCommentVNode("", true),
                          (_ctx.printData.degree==7)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_104, "MBA/EMBA"))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", _hoisted_105, [
                            _createElementVNode("div", _hoisted_106, _toDisplayString(item.description), 1)
                          ])
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  (_ctx.printData.experience)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.printData.experience.works, (item, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          style: {},
                          key: i
                        }, [
                          _createElementVNode("td", _hoisted_107, [
                            _createElementVNode("div", _hoisted_108, _toDisplayString(item.date_start.slice(0,7)) + "至" + _toDisplayString(item.date_end.slice(0,7)), 1)
                          ]),
                          _createElementVNode("td", _hoisted_109, [
                            _createElementVNode("div", _hoisted_110, _toDisplayString(item.description), 1)
                          ]),
                          _createElementVNode("td", _hoisted_111, [
                            _createElementVNode("div", _hoisted_112, _toDisplayString(item.job_title), 1)
                          ]),
                          _createElementVNode("td", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, _toDisplayString(item.certifier_name), 1)
                          ]),
                          _createElementVNode("td", _hoisted_115, [
                            _createElementVNode("div", _hoisted_116, _toDisplayString(item.certifier_mobile), 1)
                          ])
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  _hoisted_117,
                  _hoisted_118,
                  _hoisted_119,
                  _hoisted_120,
                  _hoisted_121,
                  _hoisted_122
                ]),
                _hoisted_123,
                _createElementVNode("div", _hoisted_124, [
                  _hoisted_125,
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("table", _hoisted_127, [
                      _createElementVNode("tr", _hoisted_128, [
                        (_ctx.printData.questions)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.printData.questions.slice(0, 39), (item, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                style: {"border":"none"},
                                key: index,
                                colspan: "12"
                              }, _toDisplayString(index + 1) + "、" + _toDisplayString(item.title) + " 答案：" + _toDisplayString(item.answer_lable), 1))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("tr", _hoisted_129, [
                        (_ctx.printData.questions)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.printData.questions.slice(39, 65), (item, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                style: {"border":"none","font-size":"14px"},
                                key: index,
                                colspan: "12"
                              }, _toDisplayString(index + 40) + "、" + _toDisplayString(item.title) + " 答案：" + _toDisplayString(item.answer_lable), 1))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_130, [
                          _createElementVNode("table", null, [
                            _hoisted_131,
                            (_ctx.printData.group_results)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.printData.group_results, (ans, index2) => {
                                  return (_openBlock(), _createElementBlock("tr", null, [
                                    _createElementVNode("td", null, _toDisplayString(ans.title), 1),
                                    _createElementVNode("td", null, _toDisplayString(ans.number), 1),
                                    _createElementVNode("td", null, _toDisplayString(ans.score), 1)
                                  ]))
                                }), 256))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.printData.group_results)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_133, [
                                    _hoisted_134,
                                    _createElementVNode("span", _hoisted_135, [
                                      _createElementVNode("span", null, [
                                        _hoisted_136,
                                        _createElementVNode("span", _hoisted_137, "    " + _toDisplayString(_ctx.printData.group_results[0].score+_ctx.printData.group_results[3].score+_ctx.printData.group_results[4].score+_ctx.printData.group_results[7].score) + "    ", 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_138, [
                                        _hoisted_139,
                                        _createElementVNode("span", _hoisted_140, "    " + _toDisplayString(_ctx.printData.group_results[1].score+_ctx.printData.group_results[2].score+_ctx.printData.group_results[5].score+_ctx.printData.group_results[6].score) + "    ", 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_141, [
                                    _createElementVNode("span", _hoisted_142, [
                                      _createElementVNode("span", null, [
                                        _hoisted_143,
                                        _createElementVNode("span", _hoisted_144, "    " + _toDisplayString(_ctx.printData.group_results[0].score+_ctx.printData.group_results[3].score+_ctx.printData.group_results[4].score+_ctx.printData.group_results[7].score+_ctx.printData.group_results[1].score+_ctx.printData.group_results[2].score+_ctx.printData.group_results[5].score+_ctx.printData.group_results[6].score) + "    ", 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_145
          ])
        ])
      ]),
      _: 1
    })
  ]))
}